<div style="background-color: #e7ecf2">
  <div
    class="d-flex gap-4 h-100"
    style="background-color: #e7ecf2; overflow: auto"
    [class.drawer-open]="isDrawerActive()"
  >
    <div
      class="flex-grow-1 d-flex flex-column gap-3"
      style="padding: 20px; height: 100vh"
    >
      @if (displayNavBar) {
        <app-navbar />
      }
      <div
        style="background-color: #fff; border-radius: 20px; padding: 20px"
        class="for-side-panel-only"
      >
        <ng-content />
      </div>
    </div>
    @if (isPinned()) {
      <app-task-drawer></app-task-drawer>
    }
  </div>
</div>
